import React from "react";
import {
  Text,
  TableContainer,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
} from "@chakra-ui/react";
import {
  Card, CardHeader, CardTitle, CardContent
} from "../../../../components/Card";
import Link from "../../../../components/Link";
import ShortenedText from "../../../../components/ShortenedText";
import urlToId from "../../../../helpers/UrlToId";
import { translateType } from "../../../../shared/libs/translate";
import { ServiceState } from "../../../../components/States";

export function ServiceListModalView({ services }) {
  const columns = [
    {
      title: "Ürün",
      dataIndex: "related_model",
      render: (text, record) => (
        <Link to={`/servis/${urlToId(record.url) || ""}`}>{text?.name || "--"}
        </Link>
      ),
    },
    {
      title: "TİP",
      dataIndex: "service_type",
      render: (text) => (<>{translateType(text)}</>),
    },
    {
      title: "Açıklama",
      dataIndex: "desc",
      render: (text) => (<ShortenedText text={text} maxLength={80} />),
    },
    {
      title: "Durum",
      dataIndex: "state",
      render: (text) => (<ServiceState state={text}></ServiceState>),
    },
  ];
  return (
    <Card>
      <CardHeader isNaive={true}>
        <CardTitle isNaive={true}>Servis Kayıtları</CardTitle>
      </CardHeader>
      <CardContent>
        <TableContainer whiteSpace="wrap">
          <Table>
            {services && services.length > 0 ? (
              <>
                <Thead>
                    <Tr>
                    {columns.map((column) => (
                      <Th key={column.dataIndex}>{column.title}</Th>
                    ))}
                  </Tr>
                </Thead>
                <Tbody>
                  {services.map((t) => (
                    <Tr key={t.number}>
                      {columns.map((column) => (
                        <Td key={column.dataIndex}>
                          {column.render ? (
                            column.render(t[column.dataIndex], t)
                          ) : (
                            <span>{t[column.dataIndex]}</span>
                          )}
                        </Td>
                      ))}
                    </Tr>
                  ))}
                </Tbody>
              </>
            ) : (
              <>
                <Text textAlign="center">
                  Henüz oluşturulmuş bir servis kaydı yok
                </Text>
              </>
            )}
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
}

export default function ServiceListTableView({ services }) {
  return <ServiceListModalView services={services} />;
}
